<svg
  width="500"
  height="500"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="-70 -10 500 500"
>
  <defs>
    <style>
      .cls-1,
      .cls-2 {
        fill: none;
        stroke: #3615ff;
        stroke-miterlimit: 10;
      }

      .cls-1 {
        stroke-width: 2px;
      }

      .cls-3 {
        fill: #3615ff;
      }
    </style>
  </defs>
  <text
    x="10"
    y="20"
    fill="#3615ff"
    x="280"
    y="110"
  >
    COG
  </text>
  <g transform="translate(270, 90)">
    <line
      stroke="#3615ff"
      stroke-width="1.5"
      x1="7.2"
      y1="0.3"
      x2="7.7"
      y2="53.4"
      id="svg_1"
    />
    <line
      stroke="#3615ff"
      stroke-width="1.5"
      x1="7.3"
      y1="0.9"
      x2="10.9"
      y2="7.2"
      id="svg_2"
      transform="rotate(-1.2 9.1, 4.1) "
    />
    <path
      stroke="#3615ff"
      stroke-width="1.5"
      transform="rotate(61.4 5.3, 4.1) "
      d="m3.483586,1.117517l3.727494,6.001603"
      id="svg_3"
    />
  </g>

  @if (posAndWeathStore.vm().isWindArrowVisible) {
    <g class="windDirection">
      <text
        class="windDirectionArrowText"
        fill="#4472c4"
        x="-30"
        y="20"
      >
        ● Wind Direction
      </text>
      <g
        class="windDirectionArrow"
        [attr.transform]="posAndWeathStore.vm().windDirectionTransform"
      >
        <line
          stroke="#4472c4"
          stroke-width="1.5"
          x1="7.2"
          y1="0.1"
          x2="7.7"
          y2="53.4"
          id="svg_1"
        />
        <line
          stroke="#4472c4"
          stroke-width="1.5"
          x1="7.3"
          y1="0.9"
          x2="10.9"
          y2="7.2"
          id="svg_2"
          transform="rotate(-1.2 9.1,4.1) "
        />
        <path
          stroke="#4472c4"
          stroke-width="1.5"
          transform="rotate(61.4 5.3, 4.1)"
          d="m3.483586,1.117517l3.727494,6.001603"
          id="svg_3"
        />
      </g>
    </g>
  }

  @if (posAndWeathStore.vm().isWaveArrowVisible) {
    <g class="waveDirection">
      <text
        class="waveDirectionArrowText"
        fill="#00b050"
        x="-30"
        y="40"
      >
        ● Wave Direction
      </text>
      <g
        class="waveDirectionArrow"
        [attr.transform]="posAndWeathStore.vm().waveDirectionTransform"
      >
        <line
          stroke="#00b050"
          stroke-width="1.5"
          x1="7.2"
          y1="0.3"
          x2="7.7"
          y2="53.4"
          id="svg_1"
        />
        <line
          stroke="#00b050"
          stroke-width="1.5"
          x1="7.3"
          y1="0.9"
          x2="10.9"
          y2="7.2"
          id="svg_2"
          transform="rotate(-1.2 9.1, 4.1)"
        />
        <path
          stroke="#00b050"
          stroke-width="1.5"
          transform="rotate(61.4 5.3, 4.1)"
          d="m3.483586,1.117517l3.727494,6.001603"
          id="svg_3"
        />
      </g>
    </g>
  }

  @if (posAndWeathStore.vm().isCurArrowVisible) {
    <g class="swellDirection">
      <text
        class="swellDirectionArrowText"
        fill="#ffc000"
        x="-30"
        y="60"
      >
        ● Current Direction
      </text>
      <g
        class="swellDirectionArrow"
        [attr.transform]="posAndWeathStore.vm().currentDirectionTransform"
      >
        <line
          stroke="#ffc000"
          stroke-width="1.5"
          x1="7.2"
          y1="0.3"
          x2="7.7"
          y2="53.4"
          id="svg_1"
        />
        <line
          stroke="#ffc000"
          stroke-width="1.5"
          x1="7.3"
          y1="0.9"
          x2="10.9"
          y2="7.2"
          id="svg_2"
          transform="rotate(-1.2 9.1, 4.1) "
        />
        <path
          stroke="#ffc000"
          stroke-width="1.5"
          transform="rotate(61.4 5.3,4.1) "
          d="m3.5, 1.1 l3.7, 6.0"
          id="svg_3"
        />
      </g>
    </g>
  }
  <path
    id="svg_1"
    class="cls-1"
    d="
        m261.2,296.4
        a68.7,45.5 0 0 1 -6.0,-5.8
        a67.5,44.7 0 0 1 -6.0,-9.1
        c-3.9,-7.9 -6.8,-13.7 -9.0,-22.3
        a254.1,168.5 0 0 1 -3.0,-19.0
        q-0.6,-5.5 -0.8,-10.8
        l0,-117.1
        c0,-2.8 0.1,-6.6 0.8,-11.2
        a120.5,80.0 0 0 1 3.0,-13.2
        a107.1,71.0 0 0 1 7.5,-13.2
        a34.2,22.7 0 0 1 6.0,-5.8
        a28.1,18.6 0 0 1 6.0,-3.3
        a34.1,22.6 0 0 1 9.0,-2.5
        a26.2,17.4 0 0 1 6.0,-0.9
        a21.1,14.0 0 0 1 2.2,0
        a22.4,14.9 0 0 1 6.0,0.9
        a39.3,26.1 0 0 1 9.0,2.5
        a27.6,18.3 0 0 1 6.0,3.3
        a34.7,23.0 0 0 1 6.0,5.8
        a108.2,71.7 0 0 1 7.5,13.2
        a121.3,80.5 0 0 1 3.0,13.2
        c0.8,5.7 0.8,10.1 0.8,11.2
        c0,12.7 0.7,100.0 0,117.1
        c-0.1,3.2 -0.4,6.3 -0.4,6.3
        s-0.2,2.2 -0.4,4.5
        c-1.2,12.0 -3.0,19.0 -3.0,19.0
        c-2.1,8.4 -5.0,14.2 -9.0,22.3
        a68.2,45.2 0 0 1 -6.0,9.1
        a71.4,47.4 0 0 1 -6.0,5.8
      "
  />
  <path
    class="cls-1"
    d="m234.7,114.41"
    id="svg_2"
  />
  <path
    class="cls-1"
    d="m280.5,46.1"
    id="svg_3"
  />
  <path
    class="cls-1"
    d="m275.9,45.1"
    id="svg_4"
  />
  <path
    class="cls-1"
    d="m272.4,342.6"
    id="svg_5"
  />
  <line
    class="cls-1"
    x1="290.2"
    y1="295.4"
    x2="261.3"
    y2="295.4"
    id="svg_6"
  />
  <rect
    class="cls-1"
    x="246.9"
    y="234.0"
    width="58.0"
    height="27"
    id="svg_7"
  />
  <ellipse
    class="cls-3"
    id="svg_10"
  />
</svg>
